import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
import accounts from './accounts'
import twoFactor from './two-factor'
/**
* @see \App\Http\Controllers\UserController::index
* @see app/Http/Controllers/UserController.php:36
* @route '/users'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/users',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\UserController::index
* @see app/Http/Controllers/UserController.php:36
* @route '/users'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\UserController::index
* @see app/Http/Controllers/UserController.php:36
* @route '/users'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\UserController::index
* @see app/Http/Controllers/UserController.php:36
* @route '/users'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\UserController::store
* @see app/Http/Controllers/UserController.php:67
* @route '/users'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/users',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\UserController::store
* @see app/Http/Controllers/UserController.php:67
* @route '/users'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\UserController::store
* @see app/Http/Controllers/UserController.php:67
* @route '/users'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\UserController::edit
* @see app/Http/Controllers/UserController.php:83
* @route '/users/{user}/edit'
*/
export const edit = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/users/{user}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\UserController::edit
* @see app/Http/Controllers/UserController.php:83
* @route '/users/{user}/edit'
*/
edit.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return edit.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\UserController::edit
* @see app/Http/Controllers/UserController.php:83
* @route '/users/{user}/edit'
*/
edit.get = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\UserController::edit
* @see app/Http/Controllers/UserController.php:83
* @route '/users/{user}/edit'
*/
edit.head = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\UserController::update
* @see app/Http/Controllers/UserController.php:98
* @route '/users/{user}'
*/
export const update = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/users/{user}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\UserController::update
* @see app/Http/Controllers/UserController.php:98
* @route '/users/{user}'
*/
update.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return update.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\UserController::update
* @see app/Http/Controllers/UserController.php:98
* @route '/users/{user}'
*/
update.put = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\UserController::update
* @see app/Http/Controllers/UserController.php:98
* @route '/users/{user}'
*/
update.patch = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\UpdateUserPasswordController::__invoke
* @see app/Http/Controllers/UpdateUserPasswordController.php:14
* @route '/users/{user}/update-password'
*/
export const updatePassword = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updatePassword.url(args, options),
    method: 'put',
})

updatePassword.definition = {
    methods: ["put"],
    url: '/users/{user}/update-password',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\UpdateUserPasswordController::__invoke
* @see app/Http/Controllers/UpdateUserPasswordController.php:14
* @route '/users/{user}/update-password'
*/
updatePassword.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return updatePassword.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\UpdateUserPasswordController::__invoke
* @see app/Http/Controllers/UpdateUserPasswordController.php:14
* @route '/users/{user}/update-password'
*/
updatePassword.put = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updatePassword.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\ToggleUserDeletedStateController::__invoke
* @see app/Http/Controllers/ToggleUserDeletedStateController.php:23
* @route '/users/{user}/toggle-deleted'
*/
export const toggleDeleted = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleDeleted.url(args, options),
    method: 'put',
})

toggleDeleted.definition = {
    methods: ["put"],
    url: '/users/{user}/toggle-deleted',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ToggleUserDeletedStateController::__invoke
* @see app/Http/Controllers/ToggleUserDeletedStateController.php:23
* @route '/users/{user}/toggle-deleted'
*/
toggleDeleted.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return toggleDeleted.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ToggleUserDeletedStateController::__invoke
* @see app/Http/Controllers/ToggleUserDeletedStateController.php:23
* @route '/users/{user}/toggle-deleted'
*/
toggleDeleted.put = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: toggleDeleted.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\User\ResendEmailVerificationController::__invoke
* @see app/Http/Controllers/User/ResendEmailVerificationController.php:16
* @route '/users/{user}/resend-email-verification'
*/
export const resendEmailVerification = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resendEmailVerification.url(args, options),
    method: 'post',
})

resendEmailVerification.definition = {
    methods: ["post"],
    url: '/users/{user}/resend-email-verification',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\ResendEmailVerificationController::__invoke
* @see app/Http/Controllers/User/ResendEmailVerificationController.php:16
* @route '/users/{user}/resend-email-verification'
*/
resendEmailVerification.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return resendEmailVerification.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\ResendEmailVerificationController::__invoke
* @see app/Http/Controllers/User/ResendEmailVerificationController.php:16
* @route '/users/{user}/resend-email-verification'
*/
resendEmailVerification.post = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resendEmailVerification.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\ManuallyVerifyEmailController::__invoke
* @see app/Http/Controllers/User/ManuallyVerifyEmailController.php:16
* @route '/users/{user}/manually-verify-email'
*/
export const manuallyVerifyEmail = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: manuallyVerifyEmail.url(args, options),
    method: 'post',
})

manuallyVerifyEmail.definition = {
    methods: ["post"],
    url: '/users/{user}/manually-verify-email',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\ManuallyVerifyEmailController::__invoke
* @see app/Http/Controllers/User/ManuallyVerifyEmailController.php:16
* @route '/users/{user}/manually-verify-email'
*/
manuallyVerifyEmail.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return manuallyVerifyEmail.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\ManuallyVerifyEmailController::__invoke
* @see app/Http/Controllers/User/ManuallyVerifyEmailController.php:16
* @route '/users/{user}/manually-verify-email'
*/
manuallyVerifyEmail.post = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: manuallyVerifyEmail.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\SecurityController::__invoke
* @see app/Http/Controllers/User/SecurityController.php:15
* @route '/users/{user}/security'
*/
export const security = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(args, options),
    method: 'get',
})

security.definition = {
    methods: ["get","head"],
    url: '/users/{user}/security',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\SecurityController::__invoke
* @see app/Http/Controllers/User/SecurityController.php:15
* @route '/users/{user}/security'
*/
security.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return security.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\SecurityController::__invoke
* @see app/Http/Controllers/User/SecurityController.php:15
* @route '/users/{user}/security'
*/
security.get = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\SecurityController::__invoke
* @see app/Http/Controllers/User/SecurityController.php:15
* @route '/users/{user}/security'
*/
security.head = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: security.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\ToolsController::__invoke
* @see app/Http/Controllers/User/ToolsController.php:15
* @route '/users/{user}/tools'
*/
export const tools = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tools.url(args, options),
    method: 'get',
})

tools.definition = {
    methods: ["get","head"],
    url: '/users/{user}/tools',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\ToolsController::__invoke
* @see app/Http/Controllers/User/ToolsController.php:15
* @route '/users/{user}/tools'
*/
tools.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return tools.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\ToolsController::__invoke
* @see app/Http/Controllers/User/ToolsController.php:15
* @route '/users/{user}/tools'
*/
tools.get = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tools.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\ToolsController::__invoke
* @see app/Http/Controllers/User/ToolsController.php:15
* @route '/users/{user}/tools'
*/
tools.head = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: tools.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\UpdateAccountController::__invoke
* @see app/Http/Controllers/User/UpdateAccountController.php:17
* @route '/users/{user}/update-account'
*/
export const updateAccount = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateAccount.url(args, options),
    method: 'put',
})

updateAccount.definition = {
    methods: ["put"],
    url: '/users/{user}/update-account',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\User\UpdateAccountController::__invoke
* @see app/Http/Controllers/User/UpdateAccountController.php:17
* @route '/users/{user}/update-account'
*/
updateAccount.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return updateAccount.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UpdateAccountController::__invoke
* @see app/Http/Controllers/User/UpdateAccountController.php:17
* @route '/users/{user}/update-account'
*/
updateAccount.put = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateAccount.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\ExportUsersActionController::__invoke
* @see app/Http/Controllers/ExportUsersActionController.php:18
* @route '/users/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/users/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ExportUsersActionController::__invoke
* @see app/Http/Controllers/ExportUsersActionController.php:18
* @route '/users/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ExportUsersActionController::__invoke
* @see app/Http/Controllers/ExportUsersActionController.php:18
* @route '/users/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ExportUsersActionController::__invoke
* @see app/Http/Controllers/ExportUsersActionController.php:18
* @route '/users/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

const users = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    updatePassword: Object.assign(updatePassword, updatePassword),
    toggleDeleted: Object.assign(toggleDeleted, toggleDeleted),
    resendEmailVerification: Object.assign(resendEmailVerification, resendEmailVerification),
    manuallyVerifyEmail: Object.assign(manuallyVerifyEmail, manuallyVerifyEmail),
    accounts: Object.assign(accounts, accounts),
    security: Object.assign(security, security),
    twoFactor: Object.assign(twoFactor, twoFactor),
    tools: Object.assign(tools, tools),
    updateAccount: Object.assign(updateAccount, updateAccount),
    export: Object.assign(exportMethod, exportMethod),
}

export default users